import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

const CSVDialog = ({ columns, rows, additionalData, filename }) => {
	const exportCSV = () => {
		let csv = [];
		const csv_columns = columns.map((item) => {
			return item.headerName;
		});
		const csv_rows = rows.map((item) => {
			let row = columns.map((row) => {
				return `"${item[row.field] || ''}"`;
			});
			return row.join(',');
		});
		if (additionalData) {
			csv.push(additionalData.join(','));
		}
		csv.push(csv_columns.join(','));
		csv.push(csv_rows.join('\r'));
		csv = csv.join('\n');
		downloadCSV(csv, filename);
	}

	const downloadCSV = (csv, filename) => {
		var csvFile;
		var downloadLink;

		csvFile = new Blob([csv], { type: "text/csv" });
		downloadLink = document.createElement("a");
		downloadLink.download = filename;
		downloadLink.href = window.URL.createObjectURL(csvFile);
		downloadLink.style.display = "none";
		document.body.appendChild(downloadLink);
		downloadLink.click();
	}

	return (
		<div style={{ paddingTop: '15px' }}>
			<Tooltip title="Generate CSV">
				<Button
					color="primary"
					variant="contained"
					onClick={exportCSV}
				>
					CSV Export
				</Button>
			</Tooltip>
		</div >
	)
}

CSVDialog.propTypes = {
}

export default CSVDialog
